module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud.eefee7a4367ba737d2f23e0e3e6d75be.png";